// Packages
import { merge } from 'rambda';

// Types
import { TThemeColors, TCssClassMap } from "src/interface";


/**
 * Builds the CSS class map with with the mode and color classes based on the classes provided .
 *
 * If the `color` is a string, then a CSS class will be added to the
 * `cssClassMap` with the key `fx-color-${color}`.
 *
 * If the `color` is not a string, or is a empty string, then the
 * `cssClassMap` is returned as is.
 *
 * @param {TThemeColors | string | null} color - The color to add to the class map.
 * @param {TCssClassMap} [cssClassMap={}] - The CSS class map to add the color to.
 * @returns {TCssClassMap} The class map with the color added.
 */
export const buildColorClasses = (color: TThemeColors | string | undefined | null, cssClassMap: TCssClassMap = {}) => {
  return typeof color === 'string' && color.length ?
    merge({
      [`fx-color-${color}`]: true,
      'fx-color-theme': true
    },
      cssClassMap
    ) :
    cssClassMap;
}
